<template>
    <div :class="['scope-toggle-wrapper', { '-checked': model === true }]">
        <input
            type="checkbox"
            class="scope-toggle-wrapper__checkbox"
            :checked="model"
            :name="name"
            @change="onChange"
        />
        <div class="scope-toggle-wrapper__indicator" />
    </div>
</template>

<script setup>
import { defineModel, defineProps } from 'vue';
const model = defineModel();
const emit = defineEmits(['change']);
defineProps({
    name: String
});

const onChange = () => {
    model.value = !model.value;
    emit('change', model.value);
};
</script>

<style lang="scss" scoped>
@import '../assets/styles/_main.scss';

.scope-toggle-wrapper {
    display: inline-block;
    height: 18px;
    width: 32px;
    min-width: 32px;
    position: relative;
    overflow: hidden;
    border-radius: 20px;
    cursor: pointer;

    &__checkbox {
        z-index: 2;
        opacity: 0;
        cursor: pointer;
    }

    &__checkbox,
    &__indicator {
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: 0;
    }

    &__indicator {
        background: $icons-low-emphasis;
        @include transition-default;

        &:after {
            height: 13px;
            width: 13px;
            background: $icons-light;
            @include shadow-medium;
            content: '';
            position: absolute;
            border-radius: 100%;
            top: 2.5px;
            left: 2.5px;
            @include transition-default(transform);
        }
    }

    &.-checked {
        .scope-toggle-wrapper__indicator {
            background: $icons-success-accent;
            &::after {
                transform: translateX(14.5px);
            }
        }
    }
}
</style>
